import { useState } from "react";
import { useDeleteInventoryType } from "../../../hooks/inventory-type";
import { InventoryType } from "../../../models";
import { ModalContainerChangeDetection } from "../../ui";
import { GenericDataGrid } from "../generic-grid/Generic.grid";
import { inventoryTypeColumns as columns } from "./inventory-type.columns";
import { InventoryTypeForm } from "../../forms";
import { SxProps, Theme } from "@mui/material";

interface Props<T> {
  rows: T[];
  loading: boolean;
  onClick?: (entity: T) => void;
  onLink?: (entity: T) => void;
  onModalClosed?: () => void;
  title?: string;
  autoHeight?: boolean;
  disableColumnsButton?: boolean;
  disableExport?: boolean;
  disableQuickFilter?: boolean;
  disableCreate?: boolean;
  sx?: SxProps<Theme>;
}

export const InventoryTypeDataGrid = (props: Props<InventoryType>) => {
  const {
    rows,
    loading,
    onClick,
    onLink,
    onModalClosed,
    title,
    autoHeight,
    disableColumnsButton,
    disableExport,
    disableQuickFilter,
    disableCreate,
    sx,
  } = props;
  const [inventoryType, setInventoryType] = useState<InventoryType>();
  const [openModal, setOpenModal] = useState(false);
  const { mutate: deleteInventoryType } = useDeleteInventoryType();

  const onEditCreate = (inventoryType?: InventoryType) => {
    inventoryType
      ? setInventoryType(inventoryType)
      : setInventoryType(undefined);
    setOpenModal(true);
  };

  return (
    <GenericDataGrid
      sx={sx}
      rows={rows}
      columns={columns}
      loading={loading}
      onClick={onClick}
      onDelete={(inventoryType) => deleteInventoryType(inventoryType.id)}
      onCreate={onEditCreate}
      onEdit={onEditCreate}
      onDoubleClick={onEditCreate}
      onLink={onLink}
      title={title}
      createTitle="Create Inventory Type"
      deleteTitle="Do you want to delete this Inventory Type"
      ignoreFields={[
        "id",
        "createdTimestamp",
        "modifiedTimestamp",
        "invoiceCategory.id",
        "invoiceCategory.createdTimestamp",
        "invoiceCategory.modifiedTimestamp",
        "invoiceCategoryId",
      ]}
      initialState={{
        sorting: {
          sortModel: [{ field: "name", sort: "desc" }],
        },
      }}
      disableColumnsButton={disableColumnsButton}
      disableExport={disableExport}
      disableQuickFilter={disableQuickFilter}
      disableCreate={disableCreate}
      autoHeight={autoHeight}
    >
      <ModalContainerChangeDetection
        open={openModal}
        handleClose={() => {
          setOpenModal(false);
          onModalClosed && onModalClosed();
        }}
        title={`${inventoryType ? "Edit" : "Create"} Inventory Type`}
      >
        <InventoryTypeForm
          onSubmitted={() => setOpenModal(false)}
          inventoryType={inventoryType}
        />
      </ModalContainerChangeDetection>
    </GenericDataGrid>
  );
};
